import type { GofundmeUserJourneysVariant } from '@percent/cause-dashboard/constants/gofundmeUserJourneys'
import type { LocaleKey } from '@percent/cause-dashboard/i18n/config'
import type { SmartApplyPartnerConfigKey } from '@percent/cause-dashboard/constants/smartApplyPartners'
import type { NativeApplyModalContext } from '@percent/cause-dashboard/constants/nativeApply/getResolvedNativeApplyContext'

export enum ProductOfferType {
  PercentService = 'PercentService',
  PartnerProduct = 'PartnerProduct',
  PercentProduct = 'PercentProduct'
}

const LinkTypes = ['calendly', 'typeform', 'external', 'internal', 'native_apply', 'register_interest'] as const

export type LinkTypeName = typeof LinkTypes[number]

interface BaseLink {
  linkType: LinkTypeName
  link: string
  linkText: LocaleKey
}

export interface CalendlyLink extends BaseLink {
  linkType: 'calendly'
}

export interface TypeformLink extends BaseLink {
  linkType: 'typeform'
  typeformId: string
}

export interface ExternalLink extends BaseLink {
  linkType: 'external'
}

export interface InternalLink extends BaseLink {
  linkType: 'internal'
}

export interface NativeApplyLink extends BaseLink {
  linkType: 'native_apply'
  partnerKey: SmartApplyPartnerConfigKey
  modalContext: NativeApplyModalContext
}

export interface RegisterInterestLink extends BaseLink {
  linkType: 'register_interest'
}

export type PrimaryButtonLink =
  | TypeformLink
  | CalendlyLink
  | ExternalLink
  | InternalLink
  | NativeApplyLink
  | RegisterInterestLink
export type SecondaryButtonLink = PrimaryButtonLink | undefined

export type ProductOffer = {
  offerId?: string
  type: ProductOfferType
  name: string
  tracking: string
  description: string
  logo?: string
  globalOverride?: boolean
  primaryButton: PrimaryButtonLink
  secondaryButton: SecondaryButtonLink
  allowedCountries?: string[]
  canBookACallOverride?: boolean
  claimApprovedOnly?: boolean
  searchTags: string[]
  experimentVariant?: GofundmeUserJourneysVariant
}
